/* eslint-disable no-underscore-dangle */
import store from '../store';

const scriptId = 'perimeterx-captcha-script';

class PerimeterxService {
    static clear() {
        delete window._pxAppId;
        delete window._pxJsClientSrc;
        delete window._pxHostUrl;
        delete window._pxVid;
        delete window._pxUuid;
        delete window._pxOnCaptchaSuccess;

        this.removeScript();
    }

    static removeScript() {
        const scriptElement = document.getElementById(scriptId);

        if (scriptElement) {
            scriptElement.parentNode.removeChild(scriptElement);
        }
    }

    static appendScript(src) {
        const script = document.createElement('script');
        script.src = src;
        script.id = scriptId;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    static getElementByIdAsync(id) {
        return new Promise((resolve, reject) => {
            let attempt = 0;
            const interval = setInterval(() => {
                const element = document.getElementById(id);
                if (element) {
                    clearInterval(interval);
                    resolve(element);
                }

                attempt += 1;

                if (attempt > 20) {
                    clearInterval(interval);
                    reject(new Error(`Element ${id} not found`));
                }
            }, 100);
        });
    }

    // px-captcha
    static showCaptcha(config) {
        this.clear();
        store.commit('captcha/SET_SHOW', true);

        return this.getElementByIdAsync('px-captcha').then((element) => {
            element.innerHTML = ''; // eslint-disable-line
            return this.init(config);
        });
    }

    static async init(config) {
        return new Promise((resolve) => {
            const {
                appId,
                vid,
                uuid,
            } = config;

            window._pxOnCaptchaSuccess = (isValid) => {
                console.log('_pxOnCaptchaSuccess', isValid);
                if (isValid) {
                    console.log('Captcha valid, resolve');
                    store.commit('captcha/SET_SHOW', false);
                    resolve();
                }
            };

            window[`_${appId}`] = {
                locale: 'en',
                challenge: {
                    view: {
                        textColor: '#181235',
                        borderColor: '#181235',
                        fillColor: '#181235',
                    },
                },
            };

            const clientId = (appId || '').substr(2);
            window._pxAppId = appId;
            window._pxJsClientSrc = `https://mercury.worldremit.com/${clientId}/init.js`;
            window._pxFirstPartyEnabled = true;
            window._pxHostUrl = `https://mercury.worldremit.com/${clientId}/xhr`;
            window._pxVid = vid;
            window._pxUuid = uuid;

            this.appendScript(`https://captcha.px-cdn.net/${clientId}/captcha.js?a=c&u=${uuid}&v=${vid}&m=0`);
        });
    }
}

export default PerimeterxService;
